import { render } from "./LayoutDefault.vue?vue&type=template&id=7a7f7ef5"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__